var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 366,
    viewBox: "0 0 1920 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.54 346.741L495.442 241.602L772.267 346.741H278.54Z",
    fill: "#66D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.355 346.741L835.286 241.602L1112.08 346.741H618.355Z",
    fill: "#66D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.764 365.958L591.797 234.096L938.975 365.958H319.764Z",
    fill: "#00B4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.99951 365.958L262.034 234.096L609.211 365.958H-9.99951Z",
    fill: "#00B4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.43 346.741L1303.36 241.602L1580.16 346.741H1086.43Z",
    fill: "#66D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.27 346.741L1643.2 241.602L1920 346.741H1426.27Z",
    fill: "#66D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.65 365.958L1399.72 234.096L1746.86 365.958H1127.65Z",
    fill: "#00B4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.889 365.958L1069.95 234.096L1417.13 365.958H797.889Z",
    fill: "#00B4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.446 65.4763C728.764 65.4763 733.672 67.2871 737.587 70.266C737.528 69.4483 737.47 68.6305 737.47 67.8128C737.47 47.1647 754.211 30.4301 774.867 30.4301C787.05 30.4301 797.831 36.2711 804.638 45.2663C808.232 19.741 830.115 0.0566406 856.643 0.0566406C885.684 0.0566406 909.203 23.5961 909.203 52.5968C909.203 53.327 909.116 54.0279 909.087 54.7288C914.375 42.4918 926.558 33.9055 940.728 33.9055C950.369 33.9055 959.105 37.8774 965.357 44.2733C971.23 27.3635 987.269 15.2142 1006.17 15.2142C1026.59 15.2142 1043.66 29.3787 1048.19 48.4205C1053.3 41.7325 1061.36 37.4101 1070.42 37.4101C1085.9 37.4101 1098.47 49.9684 1098.47 65.4471C1098.47 65.4471 1098.47 65.5056 1098.47 65.5348C1102.24 59.8689 1108.66 56.1015 1116 56.1015C1127.62 56.1015 1137.03 65.5055 1137.03 77.1292C1137.03 78.093 1136.94 79.0568 1136.83 79.9913C1139.57 78.1806 1142.85 77.1292 1146.38 77.1292C1156.05 77.1292 1163.91 84.9854 1163.91 94.6524C1163.91 104.319 1156.05 112.175 1146.38 112.175H723.446C710.533 112.175 700.073 101.72 700.073 88.8113C700.073 75.9026 710.533 65.4471 723.446 65.4471V65.4763ZM1128.94 93.6886C1128.79 93.8054 1128.65 93.9222 1128.5 94.0391L1128.85 94.6816C1128.85 94.3603 1128.94 94.0391 1128.94 93.7178V93.6886Z",
    fill: "#66D4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.239 156.504C424.54 156.504 427.579 157.497 430.12 159.191C432.136 148.998 441.106 141.317 451.887 141.317C452.938 141.317 453.932 141.405 454.954 141.551C458.226 125.751 472.221 113.864 488.991 113.864C505.761 113.864 518.733 124.933 522.619 139.915C527.265 134.688 534.043 131.387 541.581 131.387C555.195 131.387 566.298 142.106 566.94 155.569C569.336 154.343 572.024 153.583 574.887 153.583C584.558 153.583 592.417 161.44 592.417 171.106C592.417 180.773 584.558 188.63 574.887 188.63H421.268C412.386 188.63 405.199 181.445 405.199 172.567C405.199 163.688 412.386 156.504 421.268 156.504H421.239Z",
    fill: "#66D4ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.120a20e26c0dee3e278125f55377368b.svg";
export { ForwardRef as ReactComponent };